// Remember:
// Every file in scripts/ acts as an entry-point and gets tranformed to build/. Feel free to create as much as you want.
// Files in subdirectories will be ignored but you can require them in entry-point-files.
// Add an _ to a file and it will just be ignored(good for tests).
// Add your entry-point-files to templates/layout/yourlayout.html



// UTILITIES

//=require _utilities.js



// ATOMS

//=require ../../patterns/atoms/lazyload/_lazyload.js
//=require ../../patterns/atoms/animate-on-scroll/animate-on-scroll.js
//=require ../../patterns/atoms/loading-overlay/_loading-overlay.js
//=require ../../patterns/atoms/top-scroll/_top-scroll.js
//=require ../../patterns/atoms/detect-input/_detect-input.js
//=require ../../patterns/atoms/forms/_selects.js
//=require ../../patterns/atoms/icon/_icon.js
//=require ../../patterns/atoms/forms/_validation.js


// MOLECULES

// //=require ../../patterns/molecules/textrow/_textrow.js
//=require ../../patterns/molecules/masonry/_masonry.js
// //=require ../../patterns/molecules/cookieconsent/_cookieconsent.js
//=require ../../patterns/molecules/teaser/_teaser.js
// //=require ../../patterns/molecules/lightbox/_lightbox.js
// //=require ../../patterns/molecules/matomo/_matomo.js
//=require ../../patterns/molecules/share/_share.js



// ORGANISMS

//=require ../../patterns/molecules/postcard/_postcard.js
//=require ../../patterns/molecules/certificate/_certificate.js